import React from 'react';
import { motion } from 'framer-motion';
export function LoadingScreen() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-white" data-id="element-2355">
      <div className="text-center space-y-8" data-id="element-2356">
        {/* Logo with pulse animation */}
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="flex justify-center" data-id="element-2357">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aZxoSgpvWGaSLuSteDWmq1/Maybank_logo.svg" alt="Maybank" className="h-16 w-auto" data-id="element-2358" />
        </motion.div>
        {/* Loading text */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-2" data-id="element-2359">
          <h2 className="text-xl font-semibold text-gray-900" data-id="element-2360">
            Loading your dashboard
          </h2>
          <p className="text-sm text-gray-500" data-id="element-2361">Please wait a moment...</p>
        </motion.div>
        {/* Shimmer skeleton cards */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="grid grid-cols-3 gap-4 max-w-2xl mx-auto px-8" data-id="element-2362">
          {[1, 2, 3].map(i => <div key={i} className="bg-gray-100 rounded-lg h-24 overflow-hidden relative" data-id="element-2363">
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent" animate={{
            x: ['-100%', '100%']
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear',
            delay: i * 0.2
          }} style={{
            backgroundSize: '200% 100%'
          }} data-id="element-2364" />
            </div>)}
        </motion.div>
        {/* Progress bar */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="max-w-xs mx-auto" data-id="element-2365">
          <div className="h-1 bg-gray-200 rounded-full overflow-hidden" data-id="element-2366">
            <motion.div className="h-full bg-[#FFB81C] rounded-full" initial={{
            width: '0%'
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-2367" />
          </div>
        </motion.div>
        {/* Spinning loader */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="flex justify-center" data-id="element-2368">
          <div className="w-8 h-8 border-3 border-[#FFB81C] border-t-transparent rounded-full animate-spin" data-id="element-2369" />
        </motion.div>
      </div>
    </motion.div>;
}